
import { useTranslation } from 'react-i18next';
import { InjectedCounter } from '../../../InjectedCounter/InjectedCounter';



import type { ReduxProps } from './Redux.types';

export const Redux: React.FC<ReduxProps> = ({
  isCounterInjected,
  setIsCounterInjected,
  reduxStateStr,
}) => {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
      {/* Dynamic injector interface */}
      <section className="glass-panel p-6">
        <h3 className="mb-3 text-base font-bold text-text-primary">{t('statePanel')}</h3>
        <p className="text-xs md:text-sm text-text-secondary mb-5 leading-relaxed">
          By default, the Redux store contains only the static `core` reducer. When modules load, they dynamically inject their slices.
        </p>

        <button
          onClick={() => setIsCounterInjected(!isCounterInjected)}
          className={`w-full font-bold py-3.5 px-5 rounded-2xl cursor-pointer transition-all duration-300 text-sm ${
            isCounterInjected
              ? 'bg-red-500/10 text-red-500 border border-red-500/30'
              : 'bg-gradient-to-r from-primary-teal to-accent-violet text-black hover:opacity-90 shadow-md shadow-primary-teal/20'
          }`}
        >
          {isCounterInjected ? (
            <>
              <i className="fa-solid fa-circle-xmark mr-2"></i>
              Unload Counter Slice
            </>
          ) : (
            <>
              <i className="fa-solid fa-download mr-2"></i>
              Inject Counter Slice
            </>
          )}
        </button>

        {isCounterInjected && <InjectedCounter />}
      </section>

      {/* Raw store inspector */}
      <section className="glass-panel p-6 lg:col-span-2">
        <h3 className="mb-3 text-sm md:text-base font-bold text-primary-accent">Realtime Redux Store State Inspector</h3>
        <p className="text-xs md:text-sm text-text-secondary mb-4">
          Inspect how the root store object expands. Watch the state transition when clicking Inject or incrementing values.
        </p>
        <pre className="p-4 bg-[#04060a] rounded-2xl border border-white/5 text-green-400 font-mono text-xs md:text-sm max-h-[260px] overflow-y-auto">
          {reduxStateStr}
        </pre>
      </section>
    </div>
  );
};

export default Redux;
